<template>
    <main class="flex flex-row h-screen items-center justify-center">
        <form @submit.prevent="handleLogin" method="POST" class="px-8 pt-6 pb-8 mb-4 w-2/4">
            <div class="form-group">
                <Input
                    id="email"
                    type="email"
                    name="email"
                    label="Email"
                    placeholder="info@mail.eu"
                    v-model="credentials.email"
                    :errors="errors.email"
                    class="mb-4"
                    no_separator
                />

                <Input
                    id="password"
                    type="password"
                    name="password"
                    label="Password"
                    placeholder="**********"
                    v-model="credentials.password"
                    :errors="errors.password"
                    class="mb-4"
                    no_separator
                />

                <div class="flex mt-6 mb-4">
                    <label for="remember" class="flex items-center">
                        <input id="remember" type="checkbox" name="remember" class="border border-gray-200" value="true" v-model="credentials.remember">
                        <span class="ml-2">Stay connected</span>
                    </label>
                </div>

                <button class="w-full flex flex-row items-center justify-center bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
                    Sign in
                    <Loader v-if="isAuthPending"
                            class="-sm ml-2 h-4 w-4 -white border-2"/>
                </button>
            </div>
        </form>
    </main>
</template>

<script>
import Input from "../components/form/input";
import Loader from "../components/partials/loader";
import store from "../store";

export default {
    beforeMount() {
        store.dispatch('auth/getAuthUser').then( () => {
            if(store.getters['auth/auth_user']) {
                this.$store.dispatch('settings/getList')
                if(this.$route.params.to) {
                    this.$router.push({path: this.$route.params.to})
                }else {
                    this.$router.push({path: '/admin'})
                }
            }
        })
        .catch( error => console.warn(error))
        .finally( () => store.commit('auth/SET_AUTH_PENDING', false) )
    },
    data() {
        return {
            credentials: {
                email: null,
                password: null,
                remember: true,
            }
        }
    },
    computed: {
        errors() {
            return this.$store.state.auth.errors;
        },
        isAuthPending() {
            return this.$store.state.auth.isAuthPending;
        },
        authUser() {
            return this.$store.state.auth.auth_user;
        }
    },
    methods: {
        handleLogin() {
            this.$store.dispatch("auth/login", this.credentials);
        },
    },
    components: {
        Input,
        Loader
    }
}
</script>
